require("@rails/ujs").start()
require("@rails/activestorage").start()
require("../front/modules")

require.context('../../assets/images', true)   